// extracted by mini-css-extract-plugin
export default {"Path":"MenuIcon_Path__mqJRf"};